import { createUseStyles } from "react-jss";
import { getSpacing } from "../../../theme/Mixins";

export default createUseStyles({
    choices: {
        alignItems: "center",
        composes: "net-promoter__choices",
        display: "flex",
        justifyContent: "space-between",
        margin: ({theme}) => [[getSpacing(theme, 0, theme.QuestionSpacing?.WithinComponents), -3]],
    },
    dynamicChoices: {
        flexDirection: "column",
        margin: 0,
    },
    labels: {
        composes: "net-promoter__labels",
        display: "flex",
        justifyContent: "space-between",
        margin: [[20, 0]],
    },
    dynamicLabels: {
        display: "none",
    },
    label: {
        composes: "net-promoter__label",
    },
    mobileLabel: {
        textAlign: "center",
        display: "none",
    },
    dynamicMobileLabel: {
        display: "block",
    },
});
